// removed by extract-text-webpack-plugin
module.exports = {"noAdventures":"style__noAdventures__hOalb","head":"style__head__2xqW_","newAdventureButton":"style__newAdventureButton__31kUl","adventures_container":"style__adventures_container__3HiXi","adventure":"style__adventure__1GnmV","bar":"style__bar__zcKLc","title":"style__title__3ykIj","subtitle":"style__subtitle__23E7H","column":"style__column__um4Ol"};


//////////////////
// WEBPACK FOOTER
// ./src/components/account_page/adventures/style.scss
// module id = 452
// module chunks = 0